import { InjectionToken } from '@angular/core';

export const /** @type {?} */ _INITIAL_STATE = new InjectionToken(
  '@ngrx/store Internal Initial State'
);
export const /** @type {?} */ INITIAL_STATE = new InjectionToken('@ngrx/store Initial State');
export const /** @type {?} */ REDUCER_FACTORY = new InjectionToken(
  '@ngrx/store Reducer Factory'
);
export const /** @type {?} */ _REDUCER_FACTORY = new InjectionToken(
  '@ngrx/store Reducer Factory Provider'
);
export const /** @type {?} */ INITIAL_REDUCERS = new InjectionToken(
  '@ngrx/store Initial Reducers'
);
export const /** @type {?} */ _INITIAL_REDUCERS = new InjectionToken(
  '@ngrx/store Internal Initial Reducers'
);
export const /** @type {?} */ META_REDUCERS = new InjectionToken('@ngrx/store Meta Reducers');
export const /** @type {?} */ STORE_FEATURES = new InjectionToken('@ngrx/store Store Features');
export const /** @type {?} */ _STORE_REDUCERS = new InjectionToken(
  '@ngrx/store Internal Store Reducers'
);
export const /** @type {?} */ _FEATURE_REDUCERS = new InjectionToken(
  '@ngrx/store Internal Feature Reducers'
);
export const /** @type {?} */ _FEATURE_REDUCERS_TOKEN = new InjectionToken(
  '@ngrx/store Internal Feature Reducers Token'
);
export const /** @type {?} */ FEATURE_REDUCERS = new InjectionToken(
  '@ngrx/store Feature Reducers'
);



// WEBPACK FOOTER //
// ../../../modules/store/src/tokens.ts